import { ReactNode } from "react";
import PublicMenu from "./PublicMenu";
import PublicFooter from "./PublicFooter";
import "./PublicPages.css";

interface PublicPageLayoutProps {
  title: string;
  eyebrow?: string;
  intro?: string;
  navigation?: ReactNode;
  children: ReactNode;
}

export default function PublicPageLayout({ title, eyebrow = "Il parco", intro, navigation, children }: PublicPageLayoutProps) {
  return <div className="public-page">
    <PublicMenu />
    <main className="public-page__main">
      <header className="public-page__heading">
        <p className="public-page__eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
        {intro && <p className="public-page__intro">{intro}</p>}
        {navigation}
      </header>
      <div className="public-page__content">{children}</div>
    </main>
    <PublicFooter />
  </div>;
}
